// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateCarouselProduct,
    LoadRealTimePricing,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";

export const xLoadRealTimePricing: typeof LoadRealTimePricing = props => {
    // if (!props.parameter.unitOfMeasure) {
    //     return;
    // }
    // const productOption =
    //     props.getState().components.productInfoLists.productInfoListById[props.parameter.id]?.productInfoByProductId[
    //         props.parameter.productId
    //     ];
    // if (props.parameter.unitOfMeasure === productOption?.unitOfMeasure) {
    //     return;
    // }
    // const productParameter = {
    //     productId: props.parameter.productId,
    //     qtyOrdered: productOption?.qtyOrdered ?? 1,
    //     unitOfMeasure: props.parameter.unitOfMeasure,
    // };
    // props.dispatch(
    //     loadRealTimePricing({
    //         productPriceParameters: [productParameter],
    //         onSuccess: realTimePricing => {
    //             props.dispatch({
    //                 type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
    //                 id: props.parameter.id,
    //                 realTimePricing,
    //             });
    //         },
    //         onError: () => {
    //             props.dispatch({
    //                 type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
    //                 id: props.parameter.id,
    //             });
    //         },
    //         onComplete(realTimePricingProps) {
    //             if (realTimePricingProps.apiResult) {
    //                 this.onSuccess?.(realTimePricingProps.apiResult);
    //             } else if (realTimePricingProps.error) {
    //                 this.onError?.(realTimePricingProps.error);
    //             }
    //         },
    //     }),
    // );
};

// XNG-Changes
export const xDispatchUpdateCarouselProduct: typeof DispatchUpdateCarouselProduct = props => {
    const mapId = props.getState().components.productInfoLists.dataMapping[props.parameter.id];
    props.dispatch({
        type: "Components/ProductInfoLists/UpdateProduct",
        id: mapId || props.parameter.id,
        productId: props.parameter.productId,
        qtyOrdered: props.parameter.qtyOrdered,
        unitOfMeasure: props.parameter.unitOfMeasure,
    });
};

replaceInChain(chain, LoadRealTimePricing, xLoadRealTimePricing);
replaceInChain(chain, DispatchUpdateCarouselProduct, xDispatchUpdateCarouselProduct);
